var React = require('react');

function CaretDown (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"14.1712452 1.09284031 12.9386354 -0.171245215 7.17124521 5.65903325 1.40385501 -0.171245215 0.171245215 1.09284031 7.17127682 8.17124521"}));
}

CaretDown.defaultProps = {"viewBox":"0 0 14 8","version":"1.1"};

module.exports = CaretDown;

CaretDown.default = CaretDown;
